'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Felipe Thomé.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var OutsideClick = function (_React$Component) {
  _inherits(OutsideClick, _React$Component);

  function OutsideClick(props) {
    _classCallCheck(this, OutsideClick);

    var _this = _possibleConstructorReturn(this, (OutsideClick.__proto__ || Object.getPrototypeOf(OutsideClick)).call(this, props));

    _this._handleDocumentClick = _this._handleDocumentClick.bind(_this);
    return _this;
  }

  _createClass(OutsideClick, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._wasInside = false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._addListener(this.props.useCapture);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disableHandler !== this.props.disableHandler || nextProps.useCapture !== this.props.useCapture) {
        this._removeListener(this.props.useCapture);
        if (!nextProps.disableHandler) this._addListener(nextProps.useCapture);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._removeListener(this.props.useCapture);
    }
  }, {
    key: '_addListener',
    value: function _addListener(useCapture) {
      if (document) {
        document.addEventListener('click', this._handleDocumentClick, useCapture);
      }
    }
  }, {
    key: '_removeListener',
    value: function _removeListener(useCapture) {
      if (document) {
        document.removeEventListener('click', this._handleDocumentClick, useCapture);
      }
    }
  }, {
    key: '_checkForBubblePhase',
    value: function _checkForBubblePhase(event) {
      if (!this._wasInside) {
        this._handleOutsideClick(event);
      }
      this._wasInside = false;
    }
  }, {
    key: '_checkForCapturePhase',
    value: function _checkForCapturePhase(event) {
      if (this._elem && !this._elem.contains(event.target)) {
        this._handleOutsideClick(event);
      }
    }
  }, {
    key: '_handleDocumentClick',
    value: function _handleDocumentClick(event) {
      if (this.props.useCapture) {
        this._checkForCapturePhase(event);
      } else {
        this._checkForBubblePhase(event);
      }
    }
  }, {
    key: '_handleOutsideClick',
    value: function _handleOutsideClick(event) {
      if (this.props.onOutsideClick) this.props.onOutsideClick(event);
    }
  }, {
    key: '_handleWrapperClick',
    value: function _handleWrapperClick(event) {
      this._wasInside = true;
      if (this.props.onClick) this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          component = _props.component,
          onClick = _props.onClick,
          onOutsideClick = _props.onOutsideClick,
          useCapture = _props.useCapture,
          other = _objectWithoutProperties(_props, ['children', 'component', 'onClick', 'onOutsideClick', 'useCapture']);

      return _react2.default.createElement(component, _extends({
        ref: function ref(el) {
          _this2._elem = el;
        },
        onClick: function onClick(e) {
          return _this2._handleWrapperClick(e);
        }
      }, other), children);
    }
  }]);

  return OutsideClick;
}(_react2.default.Component);

;

OutsideClick.propTypes = {
  /**
   * The children of this component. They will be put inside of the root
   * element without any modification.
   */
  children: _propTypes2.default.any,
  /**
   * The component that will wrap the children. Default: "div".
   */
  component: _propTypes2.default.string,
  /**
   * If true, the handler will be removed and outside click will not be
   * be triggered. Default: false.
   */
  disableHandler: _propTypes2.default.bool,
  /**
   * This is mapped just to avoid ESLint warnings. Any property passed to
   * this component that is not direct part of its logic will be placed in the
   * root element without modification.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback that will be called with the event object when a click happens
   * outside of the wrap/root element.
   */
  onOutsideClick: _propTypes2.default.func,
  /**
   * If true, the logic of the component will use capture events.
   * Default: false.
   */
  useCapture: _propTypes2.default.bool
};

OutsideClick.defaultProps = {
  component: 'div'
};

module.exports = OutsideClick;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@gorangajic/react-outside-click/lib/OutsideClick.js
// module id = 957
// module chunks = 58